import { Suspense, lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Lazy load all page components for better performance
const Index = lazy(() => import("./pages/Index"));
const BlogPage = lazy(() => import("./pages/BlogPage"));
const ResourcesPage = lazy(() => import("./pages/ResourcesPage"));
const MediaPage = lazy(() => import("./pages/MediaPage"));
const SpeakingPage = lazy(() => import("./pages/SpeakingPage"));
const PublicationsPage = lazy(() => import("./pages/PublicationsPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const AdvisoryPage = lazy(() => import("./pages/AdvisoryPage"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-background" />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/media" element={<MediaPage />} />
            <Route path="/speaking" element={<SpeakingPage />} />
            <Route path="/publications" element={<PublicationsPage />} />
            <Route path="/advisory" element={<AdvisoryPage />} />
            <Route path="/about" element={<AboutPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
